import * as React from 'react';
import { FC } from 'react';

import { ArrowLink } from 'components/arrow-link';
import { List } from 'components/list';

import { routes } from '../../../utils/routing';
import { ContentWrap, PageHeading, SectionHeading } from '../support-form-v2.styled';

import { ICategoryGroupContent, ISupportV2CategoriesViewProps } from './types';

export const SupportV2CategoriesView: FC<ISupportV2CategoriesViewProps> = ({
  sectionTitle,
  pageTitle,
  categoryGroups,
  useremail,
  username,
  fromApp,
}) => {
  const getRoute = (group: ICategoryGroupContent) => {
    let baseRoute = `${routes.supportCategories}/${group._id}`;
    if (!fromApp) {
      return baseRoute;
    }
    baseRoute += `?fromApp=${fromApp}`;
    if (username && useremail) {
      baseRoute += `&username=${encodeURIComponent(username)}&useremail=${encodeURIComponent(
        useremail
      )}`;
    }
    return baseRoute;
  };
  return (
    <ContentWrap>
      <PageHeading aria-live="polite" data-testid="page-heading">
        {pageTitle}
      </PageHeading>

      {sectionTitle && (
        <SectionHeading aria-live="polite" data-testid="section-heading">
          {sectionTitle}
        </SectionHeading>
      )}

      <List data-testid="support-form-list">
        {categoryGroups.map(group => (
          <ArrowLink to={getRoute(group)} key={group._id}>
            {group.name}
          </ArrowLink>
        ))}
      </List>
    </ContentWrap>
  );
};
